import { createClient } from '@supabase/supabase-js';

// Helper to filter out invalid env vars
const getEnvVar = (key) => {
  const value = import.meta.env[key];
  if (!value || value === '' || value.includes('YOUR_SUPABASE') || value === 'undefined') {
    return null;
  }
  return value;
};

const envUrl = getEnvVar('VITE_SUPABASE_URL');
const envKey = getEnvVar('VITE_SUPABASE_ANON_KEY');

// Default client from environment variables (if available)
export const supabase = (envUrl && envKey) ? createClient(envUrl, envKey) : null;

// Helper to create a client manually
export const createManualClient = (url, key) => {
  try {
    return createClient(url, key);
  } catch (e) {
    console.error("Invalid Supabase credentials provided", e);
    return null;
  }
};

export const isSupabaseConnected = () => !!supabase;